// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"72234019","236":"7b7de42b","355":"77171c75","372":"0c0bbaed","917":"5d1bfeba","964":"2ad0d4d2"}[chunkId] + ".chunk.css";
};